<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M12,6C11.97,6,11.93,6,11.9,6.01C11.44,3.7199999999999998,9.42,2,7,2C4.24,2,2,4.24,2,7C2,7.11,2.01,7.22,2.02,7.33C0.83,7.89,0,9.1,0,10.5C0,12.43,1.57,14,3.5,14C3.5,14,12,14,12,14C14.21,14,16,12.21,16,10C16,7.79,14.21,6,12,6C12,6,12,6,12,6Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Cloud',
} as DefineComponent
</script>
